var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90754 4.55325C8.35973 4.00545 7.53293 3.84777 6.82196 4.1555C4.30144 5.24647 3.28216 7.82988 4.56023 9.86425C5.54032 11.4243 6.91818 13.2561 8.83111 15.1691C10.744 17.082 12.5759 18.4599 14.1359 19.4399C16.1703 20.718 18.7537 19.6987 19.8447 17.1782C20.1524 16.4672 19.9947 15.6404 19.4469 15.0926L19.1023 14.748C18.3042 13.9499 17.0829 13.7564 16.0771 14.2688L14.7971 14.9209C13.6527 15.5039 12.2631 15.2837 11.3549 14.3755L9.62465 12.6453C8.71648 11.7371 8.49632 10.3474 9.07933 9.20304L9.7314 7.92304C10.2438 6.91729 10.0503 5.696 9.25214 4.89786L9.95925 4.19076L9.25214 4.89786L8.90754 4.55325ZM10.3218 3.13904L9.63277 3.82802L10.3218 3.13904L10.6664 3.48365C12.0771 4.89443 12.4191 7.05314 11.5135 8.83089L10.8614 10.1109C10.6717 10.4833 10.7433 10.9355 11.0389 11.2311L12.7691 12.9613C13.0647 13.2569 13.5169 13.3285 13.8893 13.1388L15.1693 12.4867C16.947 11.5811 19.1058 11.923 20.5165 13.3338L20.8611 13.6784C21.9891 14.8064 22.3138 16.5088 21.6801 17.9727C20.2439 21.2909 16.4249 23.2399 13.072 21.1335C11.3934 20.0789 9.44251 18.6089 7.4169 16.5833C5.39129 14.5577 3.92124 12.6068 2.8667 10.9282C0.760277 7.57528 2.70931 3.75629 6.02752 2.32005C7.49142 1.68643 9.19381 2.0111 10.3218 3.13904Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.56388d9223145789daf6df138c5c8205.svg";
export { ForwardRef as ReactComponent };